import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import WorkRequestReducer from  './workrequest.reducer';
import WorkItemReducer from  './workitem.reducer';
import InventoryItemReducer from  './inventoryitem.reducer';
import MediaReducer from  './media.reducer';
import UserReducer from  './user.reducer';
import RoleReducer from  './role.reducer';
import DepartmentReducer from  './department.reducer';
import NotificationReducer from  './notification.reducer';
import StaffReducer from './staff.reducer';
import PhotoReducer from './photo.reducer';
import PhotoByIdReducer from './photoById.reducer';
import PhotoDocumentReducer from './photoDocument.reducer';
import {reducer as toastrReducer} from 'react-redux-toastr'

const rootReducer = combineReducers({
  workRequests: WorkRequestReducer,
  workItems: WorkItemReducer,
  inventoryItems: InventoryItemReducer,
  uploads: MediaReducer,
  users: UserReducer,
  roles: RoleReducer,
  departments: DepartmentReducer,
  notifications: NotificationReducer,
  form: formReducer,
  toastr: toastrReducer,
  staffs: StaffReducer,
  photos: PhotoReducer,
  photosById: PhotoByIdReducer,
  photoDocuments: PhotoDocumentReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js